import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-thankyou lg:bg-transparent bg-black/50 bg-blend-overlay flex align-bottom items-end" }

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Title from '../components/content/Title.vue';
import Container from '../components/content/Container.vue';
import HelpOptions from '../components/content/HelpOptions.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Confirm',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const contacts = brandService.getContacts();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"pb-20 px-4 lg:pl-16 text-left\" data-v-23466497><p class=\"font-benzin text-white text-3xl lg:text-5xl tracking-wide font-normal py-0 pb-6 my-0\" data-v-23466497>THANK <span class=\"text-brand-primary\" data-v-23466497>YOU</span></p><p class=\"text-lg text-white font-poppins tracking-normal pt-2 py-0 my-0 max-w-lg font-normal pb-8\" data-v-23466497>Your internet service set-up is now in progress. We’ll be in touch soon with the next steps to complete your activation. If you have any questions in the meantime, feel free to contact our support team.</p><a href=\"/\" type=\"button\" class=\"shadow-sm transition duration-500 ease-in-out text-center items-center justify-center px-4 py-3 md:text-md rounded-full text-white bg-transparent md:text-18 md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent border border-white border-solid font-poppins text-18 cursor-pointer hover:bg-black\" data-v-23466497> Back to Homepage </a></div>", 1)
  ])))
}
}

})